import { useContext } from "react";
import { StoreRepositoriesContext } from "./context";

export const useStoreRepositories = () => useContext(StoreRepositoriesContext);
